'use client'

import { useEffect, useState } from 'react'
import { GoogleAnalytics as GA } from '@next/third-parties/google'
import { CONSENT_EVENT, analyticsConsentGranted } from '@/lib/analytics/consent'

// The MyCIO measurement ID is baked into the frontend at build time.

export function GoogleAnalytics() {
  const [gaId, setGaId] = useState<string | null>(null)
  const [consented, setConsented] = useState(false)

  useEffect(() => {
    const id = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID_MYCIO || process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID
    setGaId(id && id !== 'G-XXXXXXXXXX' ? id : null)
    // GA loads ONLY after the banner's yes — same rule as PostHog (consent.ts). Mounting the tag is
    // itself the capture (it sets cookies and fires immediately), so the gate is on the mount.
    const sync = () => setConsented(analyticsConsentGranted())
    sync()
    window.addEventListener(CONSENT_EVENT, sync)
    return () => window.removeEventListener(CONSENT_EVENT, sync)
  }, [])

  if (!gaId || !consented) return null
  return <GA gaId={gaId} />
}
